import {
    GA_Push
} from "./GoogleAnalytics";
import {
    mobile
} from "./Agent";

var textToShare = "מסע עולמי בין 50 הכתבות הטובות של השנה: לחצו על היבשות וצאו לטיול בין הסיפורים המרתקים ביותר";
var urlToShare = "https://z.ynet.co.il/short/content/2018/LastCall/";
var textTrigger = encodeURIComponent(textToShare + " >> " + urlToShare);

const shareFacebook = () => {
    GA_Push("Share_Facebook", urlToShare);
    window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(urlToShare), "_blank");
}

const shareTwitter = () => {
    GA_Push("Share_Twitter", urlToShare);
    window.open("https://twitter.com/intent/tweet?text=" + textTrigger, "_blank");
}

const shareWhatsapp = () => {
    GA_Push("Share_WhatsApp", urlToShare);
    if (mobile()) {
        window.open("whatsapp://send?text=" + textTrigger, "_parent");
    } else {
        window.open("https://api.whatsapp.com/send?phone=&text=" + textTrigger, "_blank");
    }
}

const openNegishut = () => {
    GA_Push("Accessibility", "Open_Accessibility_Clicked");
    window.document.getElementById('INDmenu-btn').click();
}


export {
    shareFacebook,
    shareTwitter,
    shareWhatsapp,
    openNegishut
}


// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js